import type {
	LiteUserOut,
	SecodaEntityNotificationHookOut,
} from '@repo/api-codegen';
import type {
	ISecodaEntity,
	ISlackChannel,
	ISlackHook,
	IUser,
	IUserGroup,
} from '../../api';
import type { SecodaEntity } from '../../lib/models';
import { entityUrl } from '../../utils/navigationUtils';

export type OptionType = 'user' | 'group' | 'channel';

export type MultiSelectMap<T, U> = (group: T) => (item: U) => {
	label: string;
	value: string;
	group: T;
	type: OptionType;
	original: U;
};

export const selectUserMap =
	<T>(group: T) =>
	(user: IUser | LiteUserOut) => ({
		label: user?.display_name?.trim() ? user?.display_name : user?.email,
		value: user?.id,
		group,
		type: 'user',
		original: user,
	});

export const selectGroupMap =
	<T>(group: T) =>
	(groupModel: IUserGroup) => ({
		label: groupModel.name,
		value: groupModel.id,
		group,
		type: 'group',
		original: groupModel,
	});

export const selectChannelMap =
	<T>(group: T) =>
	(channel: ISlackChannel) => ({
		label: channel.name,
		value: channel.id,
		group,
		type: 'channel',
		original: channel,
	});

export const selectHookMap =
	<T>(group: T) =>
	(hook: ISlackHook | SecodaEntityNotificationHookOut) => ({
		label: hook.slack_conversation_name || '',
		value: hook.slack_conversation_id || '',
		group,
		type: 'channel',
		original: hook,
	});

export const announcementTemplate = (entity: SecodaEntity | ISecodaEntity) =>
	`[Link to the resource](${window.location.origin}${entityUrl(entity)})`;
